import React, { Dispatch, FC, SetStateAction, useState } from "react";
import { Avatar, Button, Table, Typography } from "antd";
import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";

import { formatDateWithTime } from "utils/dateFormat";

import { Image } from "antd";

import {
  GetRequireApprovePoint,
  GetRequireApprovePointData,
} from "@/services/interface";
import { numberFormat } from "utils/nuberFormat";
import ModalPointDetail from "./ModalPointDetail";
import { icons } from "antd/es/image/PreviewGroup";
import { CheckCircleOutlined, EyeFilled } from "@ant-design/icons";

interface PointTableListProps {
  data?: GetRequireApprovePointData | undefined;
  offset: number;
  limit: number;
  setOffset: Dispatch<SetStateAction<number>>;
  setLimit: Dispatch<SetStateAction<number>>;
}

const PointTableList: FC<PointTableListProps> = ({
  data,
  limit,
  offset,
  setLimit,
  setOffset,
}) => {
  const [modalData, setModalData] = useState<GetRequireApprovePoint>();

  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const columns: ColumnsType<GetRequireApprovePoint> = [
    {
      title: "ชื่อผู้เติม",
      dataIndex: "name",
      width: 200,
      render: (_text, record) => {
        return (
          <div>
            <Avatar size="small" src={record.image} />
            <Typography.Link
              onClick={() => {
                setModalData(record);
                setIsShowModal(true);
              }}
              style={{
                cursor: "pointer",
                fontWeight: "400",
                textDecoration: "underline",
                marginLeft: 8,
              }}
            >
              {_text}
            </Typography.Link>
          </div>
        );
      },
    },
    {
      title: "เบอร์โทร",
      dataIndex: "telephone",
      width: 150,
      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "จำนวนเงิน",
      dataIndex: "money_amt",
      width: 150,
      render: (_text, record) => {
        return (
          <Typography.Text>{numberFormat(record.money_amt)}</Typography.Text>
        );
      },
    },
    {
      title: "จำนวน Point ที่ได้รับ",
      dataIndex: "point_amt",
      width: 150,
      render: (_text, record) => {
        return (
          <Typography.Text>{numberFormat(record.point_amt)}</Typography.Text>
        );
      },
    },
    {
      title: "สลิปการโอน",
      dataIndex: "image_slip",
      width: 150,
      render: (_text, record) => {
        return (
          <div>
            <Image width={40} src={record.image_slip} />
          </div>
        );
      },
    },
    {
      title: "ธนาคาร",
      dataIndex: "bank_name",
      width: 150,
      render: (_text, record) => {
        return (
          <div>
            <Avatar size="small" src={record.bank_logo} />
            <Typography.Text>{_text}</Typography.Text>
          </div>
        );
      },
    },
    {
      title: "เลขที่บัญชี",
      dataIndex: "account_no",
      width: 150,
      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "ชื่อบัญชี",
      dataIndex: "account_name",
      width: 150,
      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "วันที่เติม",
      dataIndex: "create_date",
      width: "100px",
      render: (_text) => {
        return <Typography.Text>{formatDateWithTime(_text)}</Typography.Text>;
      },
    },
    // action
    {
      title: "จัดการ",
      key: "action",
      width: 80,
      render: (_text, record) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }} > 
            <Button
              size="small"
              type="default"
              onClick={() => {
                setModalData(record);
                setIsShowModal(true);
              }}
            >
              <EyeFilled />
            </Button>
          </div>
        );
      },
    },
  ];

  let filtersColumns: (
    | ColumnGroupType<GetRequireApprovePoint>
    | ColumnType<GetRequireApprovePoint>
  )[] = columns;

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          marginBottom: 16,
        }}
      >
        <div style={{ flex: 1 }}></div>
        <div
          style={{
            marginTop: "12px",
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
          }}
        ></div>
      </div>
      <Table
        rowKey="key"
        size="middle"
        // rowSelection={rowSelection}
        columns={filtersColumns}
        scroll={{ y: 600, x: true }}
        dataSource={data?.data}
        pagination={{
          pageSize: limit,
          total: parseInt(data?.total_record || "0"),
          onChange: (page, pageSize) => {
            setLimit(pageSize || 10);
            setOffset((page - 1) * pageSize);
          },
        }}
      />
      <ModalPointDetail
        isShow={isShowModal}
        onClose={() => setIsShowModal(false)}
        editData={modalData}
      />
    </div>
  );
};

export default PointTableList;
